$('.js-deviceNavButton').on('mouseenter', (e) => {
  const id = $(e.currentTarget).data('id')
  const section = $(`[data-device-id="${id}"]`)

  $(e.currentTarget)
    .addClass('is_active')
    .siblings()
    .removeClass('is_active')

  section
    .show()
    .siblings()
    .hide()
})
